export default "337f6e46c952d693.svg"